var map = {
	"./autocomplete-dropdown/template.hbs": 68598,
	"./mw-audio-options-dropdown/template.hbs": 75003,
	"./mw-badge-hint-popup/template.hbs": 49297,
	"./mw-chat-info-member-dropdown/template.hbs": 55504,
	"./mw-chat-options-dropdown/template.hbs": 62700,
	"./mw-document-options-dropdown/template.hbs": 67567,
	"./mw-emoji-name-popup/template.hbs": 75078,
	"./mw-emoji-sender-dropdown/template.hbs": 14865,
	"./mw-file-options-dropdown/template.hbs": 32428,
	"./mw-main-header-chats-dropdown/template.hbs": 13486,
	"./mw-main-header-events-dropdown/template.hbs": 61566,
	"./mw-main-header-groups-dropdown/template.hbs": 66448,
	"./mw-main-header-pages-dropdown/template.hbs": 79917,
	"./mw-main-header-user-dropdown/template.hbs": 43186,
	"./mw-profile-popup/template.hbs": 53499,
	"./mw-sort-dropdown/template.hbs": 88122,
	"./targets-dropdown/template.hbs": 21595
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80100;
module.exports = webpackAsyncContext;